<!-- Add the following to custom-day span to inspect dayRateData -->
<!-- [ngbPopover]="popContent" triggers="mouseenter:mouseleave" [openDelay]="1000" [closeDelay]="1000" -->
<ng-template #popContent><pre>{{ dayRateData() | json }}</pre></ng-template>

<!-- template is use to display rates/Complementary/no available/ no checkin /no checkout  -->

<ng-template #tooltipContent>

  @if(dayRateData()?.minLos && dayRateData()?.minLos > 1) {
    <span [innerHTML]="minLOSTooltip"></span>
  }

  @if(dayRateData()?.altPropertyAvailable) {
    <span
      [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_altPropertyAvailableTooltip"
    ></span>
  }
  @if(isComplimentary()) {
    <span
      [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_isComplimentaryTooltip"
    ></span>
  }

</ng-template>

@if(
  !isEndRange() &&
  hasDayRateData() &&
  dayRateData()?.minLos > 1
) {
  <span class="arrow restriction-apply"
    appOverlay type="tooltip"
    [content]="tooltipContent"
    [placement]="'top'"
  ></span>
}

@if(
  !isEndRange() &&
  hasDayRateData() &&
  dayRateData()?.altPropertyAvailable
) {
  <span class="arrow alt-prop-available"
    appOverlay type="tooltip"
    [content]="tooltipContent"
    [placement]="'top'"
  ></span>
}

@if(
  !isEndRange() &&  
  hasDayRateData() &&
  dayRateData()?.available &&
  dayRateData()?.isComplimentary
) {
  <i
    class="fa-solid fa-badge-check comp-icon"
    aria-hidden="true"
    appOverlay type="tooltip"
    [content]="tooltipContent"
    [placement]="'top'"
  ></i>
}

<span class="dayNumber primaryTextColor">{{ date().day | number:'2.0' }}</span>

@if(
  this.storeSvc.userStore.propertyInfo.enableRateCalendar() && isLoading() && 
  (date().equals(minDate()) || date().after(minDate()))
) {
  <span class="price-skeleton-loader justify-content-center align-items-center">
    <app-skeleton-loader
      class="d-flex"
      [removeMarginAndPadding]="true"
      [loaderData]="priceLoaderConfig()"
      [isMultiProp]="isMultiProp"
    />
  </span>
}

@if(!isLoading()) {

  @if(
    !isInRange() && !isEndRange() &&
    dayRateData()?.isClosedToArrival && !dayRateData()?.isClosedToDeparture
  ) {
    <span class="dayText text-break text-wrap" [class.text-uppercase]="isUpperCaseLabel()"
      [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_noCheckIn"
    ></span>
  }
  
  <!-- @if (
    !isEndRange(date) &&
    hasDayRateData() &&
    !dayRateData()?.available &&
    !dayRateData()?.isClosedToArrival &&
    !dayRateData()?.isClosedToDeparture
  ) {
    <span class="dayText text-break" [class.text-uppercase]="isUpperCaseLabel()"
      [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_noAvailability"
    ></span>
  } -->
  
  @if(
    !isStartRange() && !isInRange() && !isEndRange(date) &&
    dayRateData()?.isClosedToDeparture
  ) {
    <span class="dayText text-break text-wrap"
      [innerHTML]="localeObj()?.tf_1_Calendar_rateCalender_noCheckOut"
    ></span>
  }
  
  @if(
    !isEndRange(date) &&
    hasDayRateData() &&
    dayRateData()?.available &&
    isComplimentary() && (
      !dayRateData()?.isClosedToArrival && !dayRateData()?.isClosedToDeparture ||
      isStartRange() ||
      isInRange()
    )
  ) {
    <span class="dayText"
      [innerHTML]="localeObj()?.tf_1_Calendar_Loyalty_COMP_Rates"
    ></span>
  }
  
  @if(
    !isEndRange(date) &&
    hasDayRateData() &&
    dayRateData()?.available &&
    !isComplimentary() &&
    !dayRateData()?.isClosedToArrival &&
    !dayRateData()?.isClosedToDeparture &&
    !!dayRateData()?.baseRate && dayRateData()?.baseRate > dayRateData()?.dayRate
  ) {
    <del class="dayPrice baseRate text-break">
      {{ currencySymbol() }}{{ dayRateData()?.baseRate | shortenNumber: displayShortFormatPrice() : langTag() : Intl_NumberFormatOptions }}
    </del>
  }

  @if(
    (
      !isStartRange() && !isInRange() && !isEndRange(date) && !dayRateData()?.isClosedToArrival && !dayRateData()?.isClosedToDeparture ||
      (isStartRange() || isInRange())
    ) &&
    hasDayRateData() &&
    dayRateData()?.available &&
    !isComplimentary()
  ) {
    <span class="dayPrice dayRate text-break">
      {{ currencySymbol() }}{{ dayRateData()?.dayRate | shortenNumber: displayShortFormatPrice() : langTag() : Intl_NumberFormatOptions }}
    </span>
  }
}
